<template>
  <v-layout row justify-space-between id="home-footer">
    <active-workspace />

    <active-action />

    <active-tool />

    <projection />

    <coordinates />

    <scale />

    <current-client />
  </v-layout>
</template>

<script>
import Projection from "@/components/Home/Footer/Projection";
import Coordinates from "@/components/Home/Footer/Coordinates";
import Scale from "@/components/Home/Footer/Scale";
import ActiveWorkspace from "@/components/Home/Footer/ActiveWorkspace";
import ActiveAction from "@/components/Home/Footer/ActiveAction";
import ActiveTool from "@/components/Home/Footer/ActiveTool";
import CurrentClient from "@/components/Home/Footer/CurrentClient";

export default {
  name: "HomeFooter",

  components: {
    CurrentClient,
    ActiveTool,
    ActiveAction,
    ActiveWorkspace,
    Scale,
    Coordinates,
    Projection
  }
};
</script>

<style scoped>
#home-footer {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 25px;
  width: calc(100vw - 50px);
  z-index: 9;
  background: white;
  border-top: 1px solid #898a8c;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Footer/Footer.vue